import { v4 as uuidv4 } from 'uuid'
import { RequestForMovementItemsGrid } from './RequestForMovementItemsGrid'
import RequestForMovementItemsGridPluginSettings from './RequestForMovementItemsGridPluginSettings'

export const RequestForMovementItemsTab = (): ITab => {
    return {
        id: uuidv4(),
        title: "Позиции",
        view: {
            content: RequestForMovementItemsGridPluginSettings ? <RequestForMovementItemsGrid gridId={uuidv4()} plugin={RequestForMovementItemsGridPluginSettings} /> : <p> Справочник не настроен </p>,
        },
    };
}
export default RequestForMovementItemsTab